import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { Modal } from "bootstrap";
import AppBaseComponent from '../../../components/AppBaseComponent';
import Ax from "../../../components/hoc/Ax";
import Loader from '../../../components/ui/Loader/Loader';
import uuid from "react-uuid";
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import DateService from '../../../services/DateService';
import HttpAPICall from '../../../services/HttpAPICall';
import TapIcon from '../../../services/TapIcon';
import ItemViewInList from '../includes/ItemViewInList';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import TapSelect from '../../../components/ui/TapSelect';
import InputItemSearch from '../../includes/ui/InputItemSearch';
import moment from 'moment';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import download from '../../../services/DownloadFile';
import InputEmployeeSearch from '../../includes/ui/InputEmployeeSearch';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import InputSubAssemblySearch from '../../includes/ui/InputSubAssemblySearch';
import { IAM_API_BASE_URL_2, INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import TapInputNumber from '../../../components/ui/TapInputNumber';
import InputTicketSearch from '../../includes/ui/InputTicketSearch';
import Status from '../../../components/ui/Status';
import ItemDemandDetail from './ItemDemandDetail';
import InputWorkstationSearch from '../../includes/ui/InputWorkstationSearch';
import InputProjectSearch from '../../includes/ui/InputProjectSearch';
import InputCustomerSearch from '../../includes/ui/InputCustomerSearch';
import InputVendorSearch from '../../includes/ui/InputVendorSearch';
import TapHelper from '../../../services/TapHelper';


class ItemDemandList extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.initItemDemandSearchForm   =   {
            search_transaction_id           :   '',
            search_title                    :   '',
            search_warehouse_ids            :   [],
            date_range                      :   null,
            date_range_start                :   null,
            date_range_end                  :   null,
            search_item_ids                 :   [],
            search_item_tags                :   [],
            search_status_ids               :   [],
            search_demand_for               :   '',
            search_asset_ids                :   [],
            search_sub_assembly_ids         :   [],
            search_workstation_ids          :   [],
            search_employee_ids             :   [],
            search_approved_aging           :   '',
            search_voucher_aging            :   '',
            tagged_user_filter              :   '',
            tagged_user_ids                 :   [],
            'search_ticket_ids'             :   [],
            search_project_ids              :   [],
            search_vendor_ids               :   [],
            search_customer_ids             :   [],
        }

        this.purchaseSearchFormLabel    =   {
            search_transaction_id           :   'Transaction ID : ',
            search_title                    :   'Title : ',
            'search_ticket_ids'             :   'Ticket : ',
            search_warehouse_ids            :   'Warehouses : ',
            date_range                      :   'Date Range : ',
            search_item_ids                 :   'Items : ',
            search_item_tags                :   'Item Tags : ',
            search_status_ids               :   'Search Status : ',
            search_demand_for               :   'Demand For : ',
            search_asset_ids                :   'Assets : ',
            search_workstation_ids          :   'Workstation : ',
            search_employee_ids             :   'Employee : ',
            search_sub_assembly_ids         :   'Sub Assembly : ',
            search_approved_aging           :   'Approval Ageing : ',
            search_voucher_aging            :   'Voucher Ageing : ',
            tagged_user_filter              :   'User Tagging : ',
            tagged_user_ids                 :   'Tagged Users : ',
            searchedTickets                 :   [],
            search_project_ids              :   'Project : ',
            search_vendor_ids               :   'Vendors : ',
            search_customer_ids             :   'Customers : ',
        }

        this.per_page                   =   25;

        this.updateCommentFormInit      =   {
            status_id                       :   '',
            notes                           :   ' ',
        }

        this.cancelItemFormInit               =       {
            notes                             :       '',
        }

        this.state                          =   {
            minimizeTable                       :   false,
            reportDownloading                   :   false,

            data                                :   [],
            meta                                :   null,
            listLoading                         :   true,
            listingPage                         :   1,
            totalData                           :   0,
            viewLoading                         :   false,
            ItemDemandDetail                    :   null,
            openTransactionId                   :   '',
            searchedVendor                      :   [],
            searchedItem                        :   [],
            listFilterFormSubmitting            :   false,
            manufacturers                       :   [],
            formSearchedElems                   :   [],
            ItemDemandSearchForm                :   {...this.initItemDemandSearchForm},
            submittedItemDemandFilterForm       :   {...this.initItemDemandSearchForm},
            addCommentForm                      :       {...this.updateCommentFormInit},
            allAllowedStatus                    :       [],
            pdfDownloading                      :   false,
            all_periods                         :   [],
            searchedItems                       :   [],
            allStatusOptions                    :   [],
            allItemTags                         :   [],
            searchedAssets                      :   [],
            searchedEmployees                   :   [],
            searchedSubassembly                 :   [],
            allIndentOptions                    :   [],
            searchCustomers                     :   [],
            searchVendors                       :   [],
            all_warehouses                      :   [],
            userFilters                         :   [
                {value  :   'tagged_me', label  : 'My Tagged Item Demand'},
                {value  :   'created_by_me', label : 'Item Demand Created By Me'},
            ],
            allUsers                            :   [], 
            cancelledItemList                   :   [],
            cancelItemFormSubmitting            :   false,
            cancelledItemForm                   :   {...this.cancelItemFormInit},  
            searchedTickets                     :   [],
            searchedWorkstation                 :   null,
            pdfDownloading                      :   false,
            criteriaHeight                      :   0 ,
            searchedProjects                    :   [],


        };

        this.myRef                          =   React.createRef();
        this.listFilterFormModalId          =   uuid();
        this.criteriaRef                   =   React.createRef();

        this.item_profilesRef               =   React.createRef();

        this.fetchUrl                       =  INVENTORY_API_BASE_URL_2  + '/item_demand/list';
        this.formDataUrl                    =  INVENTORY_API_BASE_URL_2  + '/item_demand/form_data';
        this.detailUrl                      =  INVENTORY_API_BASE_URL_2 + '/item_demand/detail/__transaction_id';
        this.projectUrl                     =   IAM_API_BASE_URL_2 + "/project/detail/_replace_id";
        
    }

    componentDidMount() {
        setTimeout(() => this.initializeData(this.props),1000)
        this.listFilterFormModal            =   new Modal(document.getElementById(this.listFilterFormModalId),{keyboard:false,backdrop:false});
        this.releasedItemModal                            =   new Modal(document.getElementById('releasedItemModal'), {keyboard: false, backdrop :false});
       
    }
         updateCriteriaHeight = () => {
        if (this.criteriaRef.current) {
            const height = this.criteriaRef.current.offsetHeight;
            if (this.state.criteriaHeight !== height) {
                this.setState({ criteriaHeight: height });
            }
        }
    };
    componentDidUpdate(prevProps, prevState) {
        if (prevState.formSearchedElems !== this.state.formSearchedElems) {
            setTimeout(() => {
                this.updateCriteriaHeight();
            }, 1000);
        }
        if (this.props.location.search !== prevProps.location.search) {
            const { search } = this.props.location;
            const searchParams = new URLSearchParams(search);
            const searchText = TapHelper.sanitizeObject(searchParams.get('searchText'));
            if (searchText) {
                this.setState(prevState => ({
                    ItemDemandSearchForm: {
                        ...prevState.ItemDemandSearchForm,
                        search_transaction_id: searchText
                    }
                }), () => {
                    this.submitItemDemandSearchForm();
                });
            }
        }
    }

    initializeData                      =   (pr)  =>  {

         if(pr){
                let all_periods             =       [...pr.all_periods , {key : 'custom' , display : 'Custom Date Range'}] ;
               
                HttpAPICall.withAthorization('GET', this.formDataUrl, pr.access_token, null, null, (response) => {
                    let formData = response.data;
                    this.setState({
                        allIndentOptions                   :   [{value:'asset',label:'Asset'},{value:'workstation',label:'Workstation'},{value:'employee',label:'Employee'},{value:'sub_assembly',label:'Sub Assembly'}, {value:'vendor',label:'Vendor'}, {value:'customer',label:'Customer'}],
                        all_warehouses                     :       pr.all_warehouses ? pr.all_warehouses.map((m) => { return { value: m.id, label: `${m.name} (${m.code})` }}) : [] ,
                        all_periods                        :       all_periods ,
                        allStatusOptions                   :       formData && formData.group_status_list && formData.group_status_list.length > 0 ?  formData.group_status_list.map((s) => { return {value: s.id, label: s.name}; })                        : [],
                        allItemTags: pr.item_tags && pr.item_tags.length > 0 ? pr.item_tags.map((s) => { return { value: s.id, label: s.name }; }) : [],
                        allUsers: formData && formData.users ? formData.users.map((s) => { return { value: s.id, label: s.full_name, site_ids: s.linked_sites }; }) : [],
                    }, () => {
                        if (pr && pr.location && pr.location.state && pr.location.state.ItemDemandId) {
                            this.setState({
                                minimizeTable: true,
                                viewLoading: true
                            })
                        }
                        const { search } = this.props.location;
                        const searchParams = new URLSearchParams(search);
                        const searchText = TapHelper.sanitizeObject(searchParams.get('searchText'));
                        const statusFilter = TapHelper.sanitizeObject(searchParams.get('status_id'));
                        let ParamObject = new URLSearchParams(pr.location.search);
                        if (ParamObject.get('search_project_id')) {
                            this.getProjectDetail(ParamObject.get('search_project_id'))
                        } else if (searchText) {
                            this.setState(prevState => ({
                                ItemDemandSearchForm: {
                                    ...prevState.ItemDemandSearchForm,
                                    search_transaction_id: searchText
                                }
                            }), () => {
                                this.submitItemDemandSearchForm();
                            });
                        } if (statusFilter) {
                            let status = this.state.allStatusOptions.find(us => us.value == searchParams.get('status_id'));
                            let warehouse_id = this.state.all_warehouses.find(us => us.value == searchParams?.get('warehouse_id'));
                            this.setState(prevState => ({
                                ItemDemandSearchForm: {
                                    ...prevState.ItemDemandSearchForm,
                                    search_status_ids: [status.value] || [],
                                    tagged_user_filter: searchParams.get('tagged_user_filter') || "",
                                    search_warehouse_ids: searchParams?.get('warehouse_id') ? [warehouse_id?.value] : []
                                }
                            }), () => {
                                this.submitItemDemandSearchForm();
                            });
                        }
                        else {
                            this.loadListingTblData(1, pr);
                        }
                    });
                }, (err) => {

                });
        }        
    }
        getProjectDetail = (id) => {
            HttpAPICall.withAthorization("GET", this.projectUrl.replace('_replace_id', id), this.props.access_token, null, null, (resp) => {
                const projectDetail = resp.data.data
                if (projectDetail) {
                    this.setState({
                        searchedProjects: [
                            {
                                label: `${projectDetail.name} (${projectDetail.transaction_id})`,
                                display_label: `${projectDetail.name} (${projectDetail.transaction_id})`,
                                value: projectDetail.id
                            }
                        ],
                        ItemDemandSearchForm: { ...this.state.ItemDemandSearchForm, search_project_ids: [projectDetail.id] }
                    }, () => {
                        this.submitItemDemandSearchForm();
                    })
                }
    
            })
        }
    loadListingTblData                  =   (page = 1,pr=null)  =>  {
        this.setState({listLoading: true, listing_tbl_page: page});
        let params                      =   {page:page, per_page : this.per_page,...this.state.submittedItemDemandFilterForm};
        HttpAPICall.withAthorization('GET', this.fetchUrl, this.props.access_token, params, {}, (resp) => {
            let respData                =       resp.data;
            this.setState({
                data                    :   respData.data,
                meta                    :   {
                    from                :   respData.from,
                    to                  :   respData.to,
                    total               :   respData.total,
                    last_page           :   respData.last_page,
                    per_page            :   respData.per_page,
                    current_page        :   respData.current_page
                },
                // meta                 :   respData.meta,
                 totalData              :   respData.total, 
            },() => {
                if(pr && pr.location && pr.location.state && pr.location.state.ItemDemandId){
                    this.viewItemDemandDetail(pr.location.state.ItemDemandId)
                 }
            });
        }).then(() => this.setState({listLoading: false}));
    }

    viewItemDemandDetail            =   (transaction_id, refresh=false)  =>  {
        this.setState({viewLoading : true,minimizeTable : true, openTransactionId : transaction_id});
        if(this.state.ItemDemandDetail && this.state.ItemDemandDetail.transaction_id == transaction_id && refresh == false) {
            this.setState({viewLoading: false});
        } else {
            let detailUrl                       =   this.detailUrl.replace('__transaction_id', transaction_id);
            //Get Detail of Purchase Return Detail :-
            HttpAPICall.withAthorization('GET', detailUrl, this.props.access_token, {}, {}, (resp) => {
                let respData = resp.data;
               
                this.setState({
                    ItemDemandDetail        :   resp.data,
                    allAllowedStatus        :   respData && respData.change_status_list && respData.change_status_list.length > 0 ? respData.change_status_list.map((s) => { return {value: s.id, label: s.name}; }) : [] ,
                    addCommentForm          :   {...this.updateCommentFormInit , status_id : respData.data && respData.data.status ? respData.data.status.id : ''}
                });
                
            }).then(() => this.setState({viewLoading: false}));
        }
    }

    closeItemDemandDetail                =   ()  =>  {
        this.setState({viewLoading : false,minimizeTable : false, openTransactionId: null});
    }

    
    listSearchModalInit                  =   ()  =>  {
        this.listFilterFormModal.show();
    }

    viewItemModalInit                    =   (item)  =>  { 
        if(item){
            this.item_profilesRef.current.modalInit(item)
        }
    }

    submitItemDemandSearchForm                =       (e)          =>          {
        e &&  e.preventDefault()
        let serachFormKeys              =   Object.keys(this.state.ItemDemandSearchForm);
       
        let searchedElems               =   [];
        let searchParams                =   {};
        serachFormKeys.map((key)        =>  {
            
            let label                   =   this.purchaseSearchFormLabel[key];
            let value                   =   this.state.ItemDemandSearchForm[key];
           
            if(value   && value.length > 0) {
                searchParams[key]       =   value;
                if(label) {
                    let show_val        =   value;
                    if(key == 'search_transaction_id') {
                        show_val        =   this.state.ItemDemandSearchForm && this.state.ItemDemandSearchForm.search_transaction_id ? this.state.ItemDemandSearchForm.search_transaction_id : '';
                    }
                    if(key == 'search_project_ids') {
                         show_val            =   this.state.searchedProjects ? this.state.searchedProjects.map(s => s.display_label).join(', ') : '';
                        // show_val        =  this.state.ItemDemandSearchForm && this.state.ItemDemandSearchForm.search_project_id ? this.state.ItemDemandSearchForm.search_project_id : '';
                    }
                    if(key == 'search_title') {
                        show_val        =   this.state.ItemDemandSearchForm && this.state.ItemDemandSearchForm.search_title ? this.state.ItemDemandSearchForm.search_title  : '';
                    }
                    if(key == 'search_workstation_ids') {
                        show_val        =  this.state.searchedWorkstation ? this.state.searchedWorkstation.label : '';
                    }
                    if(key == 'search_item_ids') {
                        show_val        =   this.state.searchedItems ? this.state.searchedItems.map(s => s.display_label).join(', ') : '';
                    }
                    if(key == 'search_item_tags') {
                        show_val        =   this.state.allItemTags.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_status_ids') {
                        show_val        =   this.state.allStatusOptions.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_ticket_ids') {
                        show_val        =   this.state.searchedTickets ? this.state.searchedTickets.map(s => s.value).join(', ') : '';
                    }
                    
                    if(key == 'search_asset_ids') {
                        show_val        =   this.state.searchedAssets ? this.state.searchedAssets.map(s => s.display_label).join(', ') : '';
                    }
                    if(key == 'search_workstation_ids') {
                        show_val        =   this.state.searchedWorkstation ? this.state.searchedWorkstation.label : '';
                    }
                    if(key == 'search_employee_ids') {
                        show_val        =   this.state.searchedEmployees ? this.state.searchedEmployees.map(s => s.label).join(', ') : '';
                    }
                    if(key == 'search_sub_assembly_ids') {
                        show_val        =   this.state.searchedSubassembly ? this.state.searchedSubassembly.map(s => s.label).join(', ') : '';
                    }

                    if(key == 'search_customer_ids') {
                        show_val        =   this.state.searchCustomers ? this.state.searchCustomers.map(s => s.label).join(', ') : '';
                    }
                    if(key == 'search_vendor_ids') {
                        show_val        =   this.state.searchVendors ? this.state.searchVendors.map(s => s.vendor.name).join(', ') : '';
                    }
                    if(key == 'search_approved_aging') {
                        show_val        =   this.state.ItemDemandSearchForm && this.state.ItemDemandSearchForm.search_approved_aging ? this.state.ItemDemandSearchForm.search_approved_aging  : '';
                    }
                    if(key == 'search_voucher_aging') {
                        show_val        =   this.state.ItemDemandSearchForm && this.state.ItemDemandSearchForm.search_voucher_aging ? this.state.ItemDemandSearchForm.search_voucher_aging  : '';
                    }
                    if(key == 'tagged_user_filter') {
                        show_val        =   this.state.userFilters.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'tagged_user_ids') {
                        show_val        =   this.state.allUsers.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_warehouse_ids') {
                        show_val            =   this.state.all_warehouses.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'date_range') {
                        let  start_range    =      moment(this.state.ItemDemandSearchForm.date_range_start).format('DD-MMM-YYYY');
                        let end_range       =      moment(this.state.ItemDemandSearchForm.date_range_end).format('DD-MMM-YYYY')
                        let display_custom  =      `Custom Date Range (${start_range} - ${end_range})`
                        show_val            =     this.state.all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        this.setState({
            submittedItemDemandFilterForm   :   {...this.state.ItemDemandSearchForm},
            formSearchedElems               :   searchedElems
        }, () => {
            this.listFilterFormModal.hide()
            this.loadListingTblData(1);
        });
    }

    ItemDemandSearchClear                  =        ()             =>        {
        this.setState({
            formSearchedElems               :   [],
            searchedVendor                  :   [],
            searchedItem                    :   [],
            searchedAssets                  :   [],
            searchedEmployees               :   [],
            searchedSubassembly             :   [],
            searchedWorkstation             :   null,
            ItemDemandSearchForm            :   {...this.initItemDemandSearchForm},
            submittedItemDemandFilterForm   :   {...this.initItemDemandSearchForm},
            searchedProjects                :   [],
        }, () => {
            this.loadListingTblData(1);
            this.setState({
                criteriaHeight: 0
            })
            this.listFilterFormModal.hide();
            this.props.history.push('/item_demand_list')
        });
    }

    updateComment           =           ()          =>      {
        this.myRef.current.scrollIntoView()
    }

    itemDemandAdd           =       ()  =>  {
        this.props.history.push('/item_demand_add')
    }

    ItemDemandClear                  =        ()             =>        {
        this.setState({
            formSearchedElems               :   [],
            searchedVendor                  :   [],
            searchedItem                    :   [],
            searchedWorkstation             :   null,
            ItemDemandSearchForm            :   {...this.initItemDemandSearchForm},
            submittedItemDemandFilterForm   :   {...this.initItemDemandSearchForm}
        }, () => {
            this.listFilterFormModal.hide();
        });
    }

    submitUpdateCommentForm         =       (e)          =>      {
        e.preventDefault()
        this.setState({addCommentFormSubmitting : true})
        let frmData = {
             ...this.state.addCommentForm,
             transaction_id : this.state.ItemDemandDetail.transaction_id
           }
           HttpAPICall.withAthorization('PUT', INVENTORY_API_BASE_URL_2 + '/item_demand/comment', this.props.access_token, {}, { ...frmData }, (response) => {
               toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
               this.viewItemDemandDetail(this.state.ItemDemandDetail.transaction_id,true);
               this.loadListingTblData(1)
               this.setState({addCommentForm : {...this.updateCommentFormInit}})
           }).then(() => this.setState({ addCommentFormSubmitting : false }));
    }

    openUpdatePurchaseScreen        =   ()      =>  {
        this.props.history.push({ pathname: `/item_demand_add`, state: { itemDemandData: this.state.ItemDemandDetail } })
    }
   
    //***********************DELETE PDF **************************** */
    deleteItemDemand              =           (transaction_id)              =>      {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            // dangerMode: true,
            buttons: ["No", "Yes"],
        })
            .then(willDelete => {
                if (willDelete) {
                    HttpAPICall.withAthorization('DELETE', INVENTORY_API_BASE_URL_2 + '/item_demand/delete/' + transaction_id, this.props.access_token, {}, {}, (response) => {
                        toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                        this.setState({minimizeTable : false})
                        this.loadListingTblData(1)
                     }).then(() => {

                    });
                }
            });
    }


    checkAllItem() {
        let allocationItemForCheckbox      =   document.getElementsByClassName('allocation_item_id_checkbox')
        if(allocationItemForCheckbox && allocationItemForCheckbox.length > 0) {
            for (let i = 0; i < allocationItemForCheckbox.length; i++) {
                allocationItemForCheckbox[i].checked = document.getElementById('all_check_allocation').checked;
            }
        }
    }

   releasedItemModalInit       =       ()      =>      {
            this.setState({cancelledItemList : []} , () => {
            let cancelledItemList               =        this.state.cancelledItemList;
            var showErrorMessage                =   false;
            let allocationItemForCheckbox       =   document.getElementsByClassName('allocation_item_id_checkbox');
            if(allocationItemForCheckbox && allocationItemForCheckbox.length > 0) {
                for (let i = 0; i < allocationItemForCheckbox.length; i++) {
                    if(allocationItemForCheckbox[i].checked) {
                        let itemId = allocationItemForCheckbox[i].value;
                        let data = this.state.ItemDemandDetail.items.find(i => i.item_id == itemId);
                    let row                      =   {...cancelledItemList[i],...data };
                        cancelledItemList[i]     =   row;
                        let list = cancelledItemList.filter(Boolean)
                        this.setState({cancelledItemList   :   [...list],
                                    cancelledItemForm      :   {...this.cancelItemFormInit,
                                    notes : ''}}
                                    ,() => this.releasedItemModal.show())
                    
                    }
                }
            }
            if(this.state.cancelledItemList && this.state.cancelledItemList.length == 0 && !showErrorMessage){
                toast.error('Please select an Item for Cancellation', { position: toast.POSITION.TOP_RIGHT });
            }
       })
        
   }

   submitCancelItemForm            =       (e)      =>      {
    e.preventDefault()
    
    let items                   =        [...this.state.cancelledItemList];
      
    let itemsLists              =        items.map(i => {
                                          
                                             return {cancel_qty : i.new_released_qty,demand_item_id:i.demand_item_id};
                                            });
                                           
    let formData                =          {...this.state.cancelledItemForm, items : [...itemsLists],transaction_id : this.state.ItemDemandDetail.transaction_id}
    
      this.setState({ cancelItemFormSubmitting: true })
      HttpAPICall.withAthorization('PUT', INVENTORY_API_BASE_URL_2 + '/item_demand/cancel_item', this.props.access_token, {}, { ...formData }, (response) => {
          toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
          this.releasedItemModal.hide()
          this.setState({cancelledItemForm         :       {...this.cancelItemFormInit}})
          this.viewItemDemandDetail(this.state.ItemDemandDetail.transaction_id,true)
      }).then(() => this.setState({ cancelItemFormSubmitting: false }));
  }

  //***********************DOWNLOAD PDF **************************** */
  downloadPdfHandler              =    (transaction_id)     =>         {
    let detailUrl                       =   this.detailUrl.replace('__transaction_id', transaction_id);

    this.setState({ pdfDownloading: true});
    HttpAPICall.withAthorization('GET', detailUrl, this.props.access_token,{download : "download"},{},(response) => {
        download.file(response.data.file_path);
    })
    .then(() => this.setState({pdfDownloading: false}));
}


    addToAllocation = () => {

        //  this.props.addToConsumptionHandler
        let demand_item_ids = [];
        let warehouse_ids = [];
        let pendingQtyList = [];

        let purchaseItemCollections = document.getElementsByClassName('allocation_item_id_checkbox');
        if (purchaseItemCollections && purchaseItemCollections.length > 0) {
            for (let i = 0; i < purchaseItemCollections.length; i++) {
                if (purchaseItemCollections[i].checked) {
                    let selectedPurchaseData = this.state.ItemDemandDetail?.items?.find(data => data.item_id == purchaseItemCollections[i].value);
                    demand_item_ids.push(selectedPurchaseData)
                    pendingQtyList.push(purchaseItemCollections[i].getAttribute("data-pendingQty"));
                }
            }
        }
        if (demand_item_ids.length == 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT });
        } else if (pendingQtyList.includes('0')) {
            toast.error('Every item must have pendning qty more than 0', { position: toast.POSITION.TOP_RIGHT });
        } else {

            let demandStateData = {
                demandData: { ...this.state.ItemDemandDetail, items: demand_item_ids } 
            };
            this.props.history.push({ pathname: `/allocation_list/add`, state: { addAllocationFromDemand: demandStateData } });
        }
    }

    addToConsumption                  =   ()  =>  {
            
        //  this.props.addToConsumptionHandler
        let demand_item_ids                     =   [];
        let warehouse_ids                   =   [];
        let pendingQtyList              =       [];
    
        let purchaseItemCollections      =   document.getElementsByClassName('allocation_item_id_checkbox');
        if(purchaseItemCollections && purchaseItemCollections.length > 0) {
            for (let i = 0; i < purchaseItemCollections.length; i++) {
                if(purchaseItemCollections[i].checked) {
                    let selectedPurchaseData = this.state.ItemDemandDetail?.items?.find(data => data.item_id == purchaseItemCollections[i].value);
                demand_item_ids.push(selectedPurchaseData)
                pendingQtyList.push(purchaseItemCollections[i].getAttribute("data-pendingQty"));
                }
            }
        }
        
        if (demand_item_ids.length == 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT });
        }else if(pendingQtyList.includes('0')) {
            toast.error('Every item must have pendning qty more than 0', { position: toast.POSITION.TOP_RIGHT });
        }  else {
            
            let demandStateData                    =   {   
                demandData                  :   this.state.ItemDemandDetail,
                items                       :   demand_item_ids,
            };
            this.props.history.push({ pathname: `/consumption_list/add`,  state: { addConsumptionFromItemDemand : {...this.state.ItemDemandDetail,items :   demand_item_ids,}} });
        }
    }
    
    addToInventoryTransferHandler = () => {
        let demand_item_ids = [];
        let warehouse_ids = [];
       
    
        let purchaseItemCollections = document.getElementsByClassName('allocation_item_id_checkbox');
        if (purchaseItemCollections && purchaseItemCollections.length > 0) {
            for (let i = 0; i < purchaseItemCollections.length; i++) {
                if (purchaseItemCollections[i].checked) {
                    let selectedPurchaseData = this.state.ItemDemandDetail?.items?.find(data => data.item_id == purchaseItemCollections[i].value);
                    warehouse_ids.push(purchaseItemCollections[i].getAttribute("data-warehouseId"));
                    demand_item_ids.push(selectedPurchaseData)
                }
            }
        }
        let allSelectedItem         =    demand_item_ids.flat();
            const key = 'id';
        let warehouse_ids_unique            =   warehouse_ids.filter((item, i, ar) => ar.indexOf(item) === i);
        if (demand_item_ids.length == 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT });
        } else if (warehouse_ids_unique.length > 1) {
            toast.error('Every item must have pendning qty more than 0', { position: toast.POSITION.TOP_RIGHT });
        } else {
            const uniquItemIdsList      =      [...new Map(allSelectedItem.map(item => [item[key], item])).values()];
            const uniqueItemsWrapped = uniquItemIdsList.map(item => ({ item }));
            let demandStateData = {
                warehouse_id                :   warehouse_ids[0],
                demandData                  :   { items         :   demand_item_ids },
                notes                       :   "remark"
            };
            this.props.history.push({pathname: `/inventory_transfer_list/add`, state: { addInventoryFromItemDemand: demandStateData } });
        }
    }
    addToWareHouseIndent = () => {
        let demand_item_ids = [];
        let warehouse_ids = [];
        
    
        let purchaseItemCollections = document.getElementsByClassName('allocation_item_id_checkbox');
        if (purchaseItemCollections && purchaseItemCollections.length > 0) {
            for (let i = 0; i < purchaseItemCollections.length; i++) {
                if (purchaseItemCollections[i].checked) {
                    let selectedPurchaseData = this.state.ItemDemandDetail?.items?.find(data => data.item_id == purchaseItemCollections[i].value);
                    warehouse_ids.push(purchaseItemCollections[i].getAttribute("data-warehouseId"));
                    demand_item_ids.push(selectedPurchaseData)
                }}}
        let allSelectedItem         =    demand_item_ids.flat();
            const key = 'id';
        let warehouse_ids_unique            =   warehouse_ids.filter((item, i, ar) => ar.indexOf(item) === i);
        if (demand_item_ids.length == 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT });
        } else if (warehouse_ids_unique.length > 1) {
            toast.error('Every item must have pendning qty more than 0', { position: toast.POSITION.TOP_RIGHT });
        } else {
            const uniquItemIdsList      =      [...new Map(allSelectedItem.map(item => [item[key], item])).values()];
            const uniqueItemsWrapped = uniquItemIdsList.map(item => ({ item }));
            let demandStateData = {
                warehouse_id                :   warehouse_ids[0],
                demandData :{ items                      :  demand_item_ids },
                notes                       :   "remark",
                demand_for                   : this.state.ItemDemandDetail
            };
            this.props.history.push({pathname: `/warehouse_indent_add`, state: { itemDemandData: demandStateData } });
        }
    }
    
    addToRequisition = () => {
        let demand_item_ids = [];
        let warehouse_ids = [];
        
    
        let purchaseItemCollections = document.getElementsByClassName('allocation_item_id_checkbox');
        if (purchaseItemCollections && purchaseItemCollections.length > 0) {
            for (let i = 0; i < purchaseItemCollections.length; i++) {
                if (purchaseItemCollections[i].checked) {
                    let selectedPurchaseData = this.state.ItemDemandDetail?.items?.find(data => data.item_id == purchaseItemCollections[i].value);
                    warehouse_ids.push(purchaseItemCollections[i].getAttribute("data-warehouseId"));
                    demand_item_ids.push(selectedPurchaseData)
                }}}
        let allSelectedItem                 =    demand_item_ids.flat();
            const key = 'id';
        let warehouse_ids_unique            =   warehouse_ids.filter((item, i, ar) => ar.indexOf(item) === i);
        if (demand_item_ids.length == 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT });
        } else if (warehouse_ids_unique.length > 1) {
            toast.error('Every item must have pendning qty more than 0', { position: toast.POSITION.TOP_RIGHT });
        } else {
            const uniquItemIdsList         =      [...new Map(allSelectedItem.map(item => [item[key], item])).values()];
            const uniqueItemsWrapped = uniquItemIdsList.map(item => ({ item }));
           console.log(this.state.ItemDemandDetail,'hhh')
            let demandStateData            =      {
                warehouse_id                :   warehouse_ids[0],
//                demandData                  :   { items    :  demand_item_ids },
                notes                       :   "remark",
                demandData                  :   {...this.state.ItemDemandDetail, items    :  demand_item_ids}
            };
            this.props.history.push({pathname: `/requisition_list/add`, state: { itemDemandPRData: demandStateData } });
        }
    }
        
    addToPO = () => {
        let demand_item_ids = [];
        let warehouse_ids = [];
        
    
        let purchaseItemCollections = document.getElementsByClassName('allocation_item_id_checkbox');
        if (purchaseItemCollections && purchaseItemCollections.length > 0) {
            for (let i = 0; i < purchaseItemCollections.length; i++) {
                if (purchaseItemCollections[i].checked) {
                    let selectedPurchaseData = this.state.ItemDemandDetail?.items?.find(data => data.item_id == purchaseItemCollections[i].value);
                    warehouse_ids.push(purchaseItemCollections[i].getAttribute("data-warehouseId"));
                    demand_item_ids.push(selectedPurchaseData)
                }}}
        let allSelectedItem                 =    demand_item_ids.flat();
            const key = 'id';
        let warehouse_ids_unique            =   warehouse_ids.filter((item, i, ar) => ar.indexOf(item) === i);
        if (demand_item_ids.length == 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT });
        } else if (warehouse_ids_unique.length > 1) {
            toast.error('Every item must have pendning qty more than 0', { position: toast.POSITION.TOP_RIGHT });
        } else {
            const uniquItemIdsList          =      [...new Map(allSelectedItem.map(item => [item[key], item])).values()];
            const uniqueItemsWrapped = uniquItemIdsList.map(item => ({ item }));
            let demandStateData = {
                warehouse_id                :   warehouse_ids[0],
                demandData                  :   { items : demand_item_ids },
                notes                       :   "remark",
                itemDemandDetail            :   this.state.ItemDemandDetail
            };
            this.props.history.push({pathname: `/purchase_order/add`, state: { itemDemandPOData: demandStateData } });
        }
    }
        
    cloneDemandScreenInit                   =       ()      =>      {
        this.props.history.push({pathname: `/item_demand_add`, state: { itemDemandData : this.state.ItemDemandDetail  , clone : 'yes'}})
    }

    

    ItemDemandDetailJsx                    =   ()  =>  {
        //let {ItemDemandDetail}           =   {...this.state};
       
        let indent = this.state.ItemDemandDetail;
     
        return (<div className="tab_content_header">

            {!this.state.viewLoading
                ? (<Ax>
                    {indent
                        ?
                        <div>
                            <ItemDemandDetail afterChangeEvnet={(transaction_id) => {
                                this.viewItemDemandDetail(transaction_id, true);
                            }} demandData={this.state.ItemDemandDetail} checkAllItem={this.checkAllItem} />
                            <hr />
                            
                                    <div>
                                        <div className="tab_content_wrapper" ref={this.myRef}>
                                            <span className="content_heading">Comments & History</span>
                                        </div>
                                        {this.state.allAllowedStatus
                                            ? <form onSubmit={this.submitUpdateCommentForm}>
                                                <div className="my-3 row">
                                                    <label className="col-sm-3 col-form-label">Change status to</label>
                                                    <div className="col-sm-5">
                                                        <TapSelect
                                                            changeEvent={(selectedOption) => {
                                                                this.tapSelectChange(selectedOption, 'addCommentForm', 'status_id');
                                                            }}
                                                            value={this.state.allAllowedStatus.find(s => s.value == this.state.addCommentForm.status_id)}
                                                            options={this.state.allAllowedStatus}
                                                            isSearchable={false}
                                                            isDisabled={indent.change_status == 'N' || !this.props.permissions.includes('isc_item_demand_change_status') ? true  :false}
                                                            placeholder="Please Select Status"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="my-2">
                                                    <label className="form-label">Comments</label>
                                                    <textarea
                                                        name="notes"
                                                        value={this.state.addCommentForm.notes}
                                                        onChange={(e) => this.formInputHandler(e, 'addCommentForm')}
                                                        className="form-control"
                                                        placeholder="Please Add a comment"
                                                        required
                                                        style={{ height: "100px" }}
                                                    />
                                                </div>
                                                <div className="col-12 text-end">
                                                    <button type="submit" disabled={this.state.addCommentFormSubmitting ? true : false} className="btn btn-primary mx-2">
                                                        Update {this.state.addCommentFormSubmitting ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2" />) : ''}
                                                    </button>
                                                </div>
                                            </form>
                                            : null}
                                    </div>
                                    <hr />
                                    <div className="my-1">
                                        {
                                            indent && indent.comments && indent.comments.length > 0 && indent.comments.map((c, k) => {
                                                return (<Ax key={k}><div className="row">
                                                    {c.msg ? <div className="col-sm-8" dangerouslySetInnerHTML={{ __html: c.msg.split("|").join("<br />") }} /> : <div className='col-sm-8'>-</div>}
                                                    <div className="col-sm-4 text-end">
                                                        <TapIcon.imageIcon icon={TapIcon.CalenderIcon} style={{"margin-right" : "5px"}} className="img-fluid pr-5 fs12 " alt="item-action" />
                                                        <span>{DateService.dateTimeFormat(c.created_at,'DD-MMM-YYYY hh:mm A')}</span>
                                                    </div>
                                                    <div className="col-sm-12 my-1 text-sm">{c.notes}</div>
                                                </div><hr /></Ax>);
                                            })
                                        }
                                    </div>
                        </div>
                        : null}
                </Ax>)
                : <Loader />}

        </div>)
    }

    demandForData       =   (item) => {

        let type = '', name = '';
        if(!item) {
            return { type, name};
        }
        
        if(item.demand_for == 'asset') {
            type    =   'Asset : ';
            name    =   `${item.asset?.name} (${item.asset?.asset_code})`;
        } else if(item.demand_for == 'workstation') {
            type    =   'Workstation : '; 
            name    =   item.workstation?.workstation_name;
        } else if(item.demand_for == 'sub_assembly') {
            type    =   'Sub Assembly : ';
            name    =   item.sub_assembly?.name;
        } else if(item.demand_for == 'employee') {
            type    =   'Employee : ';
            name    =   item.employee?.display_full_name;
        } else if(item.demand_for == 'vendor') {
            type    =   'Vendor : ';
            name    =   item.vendor?.name;
        } else if(item.demand_for == 'customer') {
            type    =   'Customer : ';
            name    =   item.customer?.name;;
        } 
        return { type, name}
    }



    // this.state.minimizeTable
    purchaseListingTableJsx             =   ()  =>  {
        return <Ax>
             <div ref={this.criteriaRef}
                style={{
                    position: 'sticky',
                    top: 0,
                    background: 'white',
                }}>
             <DisplaySearchCriteria searchedElems={this.state.formSearchedElems} onClearFilter={this.ItemDemandSearchClear} />
             </div>
            <table className="table table-bordered bg-white table-sm">
                <thead className="table-secondary" style={{top: `${this.state.criteriaHeight}px`,
                    position: 'sticky',
                }}>
                    <tr className='text-center'>
                    {this.state.minimizeTable 
                      ? <th>Item Demand</th>
                      : <Ax>
                            <th style={{ width: "5%" }}>S.No</th>
                             <th style={{ width: "10%" }}>Transaction ID</th>
                            <th style={{ width: "10%" }} className='text-center'>Date</th>
                            <th style={{ width: "17%" }}>Warehouse</th>
                            <th style={{ width: "13%" }}>Item Demand for</th>
                            <th style={{ width: "6%" }} className='text-center'>Total Quantity</th>
                            <th style={{ width: "8%" }} className='text-center'>Status</th>
                            <th style={{ width: "5%" }}>Action</th>
                        </Ax>
                    }
                    </tr>
                </thead>
                <tbody>
                {this.state.listLoading 
                    ? <tr><td colSpan="10"><Loader /></td></tr>
                    : (this.state.data.length > 0 ? this.state.data.map((item,index) =>  <tr className={['text-center', this.state.openTransactionId == item.transaction_id ? 'bg-light' : ''].join(' ')} key={index}>
                        {this.state.minimizeTable 
                            ? <td className='text-start'>
                                <Link className="text-capitalize link-primary" onClick={() => this.viewItemDemandDetail(item.transaction_id)}>{item.transaction_id}</Link>
                                <div className='float-end text-xs'>{DateService.dateTimeFormat(item.transaction_date,'DD-MMM-YYYY')}</div>
                                <div className="mt-1">
                                    <span className="text-sm">{item.warehouse?.name ?? "-"}</span>
                                    <em className="float-end text-sm text-muted">{item.status ? item.status.name : "-"}</em>
                                </div> 
                            </td>
                            : <Ax>
                                    <td>{this.state.meta ? this.state.meta.from + index : index}</td>
                                    <td><Link className="" role="button" onClick={() => this.viewItemDemandDetail(item.transaction_id)}>{item.transaction_id}</Link></td>
                                    <td>{DateService.dateTimeFormat(item.transaction_date,'DD-MMM-YYYY')}</td>
                                    <td>{item.warehouse ? item.warehouse.name : ''}</td>
                                    <td>
                                        <div><small className='form-text'>{this.demandForData(item).type}</small>{this.demandForData(item).name}</div>
                                    </td>
                                    <td>{item.total_qty}</td>
                                    <td>{item.status ? item.status.name : ''}</td>
                                    <td className="text-center">
                                        <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                            <TapIcon.FontAwesomeIcon icon={TapIcon.faEllipsisV} />
                                        </button>
                                        <ul className="dropdown-menu" a ria-labelledby="dropdownMenuButton1">
                                            <li><Link className="dropdown-item" role="button" onClick={() => this.viewItemDemandDetail(item.transaction_id)}>View</Link></li>
                                        </ul>
                                    </td>
                                </Ax>
                            }
                        </tr> ): <tr><td colSpan={11} className='text-center'>No Record</td></tr>)
                    }
                </tbody>
            </table>
            <DisplayListPagination meta={this.state.meta} onPageChange={(e) => this.loadListingTblData(e.selected + 1)} />
        </Ax>
    }

    ItemDemandListjsx               =   ()  =>  {
        let {ItemDemandDetail}      =   this.state;
        return <Ax>
            <div className="page_title row m0">
                <div className={this.state.minimizeTable ? "col-sm-3" : "col-sm-12"}>
                    <h3>Item Demand</h3>
                    <div className="text-end mt15">
                    {!this.state.minimizeTable && <button type="button" className="btn btn-secondary"  disabled={!this.props.permissions.includes('isc_item_demand_add')} onClick={this.itemDemandAdd}>New Demand</button>}
                        {/* {!this.state.minimizeTable && <button type="button" className="btn btn-secondary" onClick={this.purchaseDownloadHandler}>
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                            {this.state.reportDownloading && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}
                        </button>} */}
                        <button type="button" className="btn btn-secondary" onClick={this.listSearchModalInit}>
                            <TapIcon.imageIcon icon={TapIcon.SearchIcon} />
                        </button>
                    </div>
                </div>
                {this.state.minimizeTable && <div className="col-sm-9">
                    <h3>Item Demand : {ItemDemandDetail && ItemDemandDetail.transaction_id ? ItemDemandDetail.transaction_id : ""}</h3>
                    <div className="text-end mt15">
                        <button type="button" disabled={(this.state.ItemDemandDetail && this.state.ItemDemandDetail.can_edit == 'N') || !this.props.permissions.includes('isc_item_demand_edit') || this.state.viewLoading ? true : false} className="btn btn-secondary" onClick={() => this.openUpdatePurchaseScreen(this.state.ItemDemandDetail?.transaction_id)}>
                            Edit
                        </button>
                        <button disabled={this.state.viewLoading} type="button" className="btn btn-secondary" onClick={() => this.updateComment()} >Update Status </button>
                        <button type="button" className="btn btn-secondary" disabled={this.state.viewLoading || this.state.pdfDownloading} onClick={() => this.downloadPdfHandler(this.state.ItemDemandDetail?.transaction_id)}><TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} /></button>
                        <button disabled={this.state.viewLoading} type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                            <TapIcon.imageIcon icon={TapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li>
                                <a role="button" href
                                    onClick={() => {
                                        if (this.props.permissions.includes('isc_item_demand_add')) {
                                            return this.cloneDemandScreenInit();
                                        }
                                    }}
                                    className={['dropdown-item',   this.props.permissions.includes('isc_item_demand_add') ? '' : 'disabled'].join(' ')}
                                            title={!this.props.permissions.includes('isc_item_demand_add') ? 'This action cannot be performed' : ''}
                                    style={{ "pointerEvents": "all" }}
                                >Clone</a>
                            </li>
                            {this.props.permissions.includes('isc-allocation-add') && <li><a
                                className={
                                    (this.state?.ItemDemandDetail?.status?.level !== 3 && this.state?.ItemDemandDetail?.status?.level !== 4) ? "dropdown-item disabled" : "dropdown-item"} role="button"
                                disabled={(this.state.ItemDemandDetail && this.state?.ItemDemandDetail?.status?.level !== 3 && this.state?.ItemDemandDetail?.status?.level !== 4) ? true : false} onClick={() => this.addToAllocation()}>Add to Allocation</a></li>
                            }
                            {this.props.permissions.includes('isc-consumption-add') && <li><a
                                className={
                                    (this.state?.ItemDemandDetail?.status?.level !== 3 && this.state?.ItemDemandDetail?.status?.level !== 4) ? "dropdown-item disabled" : "dropdown-item"} role="button"
                                disabled={(this.state.ItemDemandDetail && this.state?.ItemDemandDetail?.status?.level !== 3 && this.state?.ItemDemandDetail?.status?.level !== 4) ? true : false} onClick={() => this.addToConsumption()}>Add to Consumption</a></li>
                            }
                            {this.props.permissions.includes('isc-inventory_transfer-add') &&
                            <li><a role="button" href onClick={() => { if (this.props.permissions.includes('isc-inventory_transfer-add')) {return this.addToInventoryTransferHandler()} }}
                               className={ (this.state?.ItemDemandDetail?.status?.level !== 3 && this.state?.ItemDemandDetail?.status?.level !== 4) ? "dropdown-item disabled" : "dropdown-item"}
                               disabled={(this.state.ItemDemandDetail && this.state?.ItemDemandDetail?.status?.level !== 3 && this.state?.ItemDemandDetail?.status?.level !== 4) ? true : false} >Add to Inventory Transfer</a></li>
                             }
                              {this.props.permissions.includes('isc-item-add') && <li><a role="button" href onClick={() => { if (this.props.permissions.includes('isc-item-add')) {return this.addToWareHouseIndent()} }}className={ (this.state?.ItemDemandDetail?.status?.level !== 3 && this.state?.ItemDemandDetail?.status?.level !== 4) ? "dropdown-item disabled" : "dropdown-item"}
                               disabled={(this.state.ItemDemandDetail && this.state?.ItemDemandDetail?.status?.level !== 3 && this.state?.ItemDemandDetail?.status?.level !== 4) ? true : false} >Add to Warehouse Indent </a></li>
                             }
                              {this.props.permissions.includes('isc-purchase-requisition-add') && <li><a role="button" href onClick={() => { if (this.props.permissions.includes('isc-purchase-requisition-add')) {return this.addToRequisition()} }}className={ (this.state?.ItemDemandDetail?.status?.level !== 3 && this.state?.ItemDemandDetail?.status?.level !== 4) ? "dropdown-item disabled" : "dropdown-item"}
                               disabled={(this.state.ItemDemandDetail && this.state?.ItemDemandDetail?.status?.level !== 3 && this.state?.ItemDemandDetail?.status?.level !== 4) ? true : false} >Add to Purchase Requisition </a></li>
                               }
                               { this.props.permissions.includes('isc-item-add') && <li><a role="button" href onClick={() => { if (this.props.permissions.includes('isc-item-add')) {return this.addToPO()} }}className={ (this.state?.ItemDemandDetail?.status?.level !== 3 && this.state?.ItemDemandDetail?.status?.level !== 4) ? "dropdown-item disabled" : "dropdown-item"}
                                 disabled={(this.state.ItemDemandDetail && this.state?.ItemDemandDetail?.status?.level !== 3 && this.state?.ItemDemandDetail?.status?.level !== 4) ? true : false} >Add to Purchase Order </a></li>
                               }
                            <li><a className={!this.props.permissions.includes('isc_item_demand_item_cancel') ? "dropdown-item disabled" : "dropdown-item"} role="button" disabled={!this.props.permissions.includes('isc_item_demand_item_cancel') ? true : false} href="#" onClick={() => this.releasedItemModalInit(this.state.ItemDemandDetail?.transaction_id)}>Cancel Item</a></li>
                            <li><a className={(!this.props.permissions.includes('isc_item_demand_delete') || (this.state.ItemDemandDetail && this.state.ItemDemandDetail.can_delete == 'N') )? "dropdown-item disabled" : "dropdown-item"} role="button" disabled={(!this.props.permissions.includes('isc_item_demand_delete') || (this.state.ItemDemandDetail && this.state.ItemDemandDetail.can_delete == 'N') )? true : false} href="#" onClick={() => this.deleteItemDemand(this.state.ItemDemandDetail?.transaction_id)}>Delete</a></li>
                        </ul>
                        <button type="button" className="btn btn-secondary" onClick={this.closeItemDemandDetail}>
                            <TapIcon.imageIcon icon={TapIcon.CloseIcon} />
                        </button>
                    </div>
                </div>}
            </div>
            <div className='container-fluid pl5'>
                <div className="page_containt row">
                    <div className={['pageTbl', this.state.minimizeTable ? 'col-sm-3' : 'col-sm-12'].join(' ')} >{this.purchaseListingTableJsx()}</div>
                    {this.state.minimizeTable && <div className="tap_border_left col-sm-9 p-2 pageTbl bg-white" >{this.ItemDemandDetailJsx()}</div>}
                </div>
            </div>
        </Ax>
    }

    listFilterFormModalJsx = () => {
        const search_demand_for =  this.state.ItemDemandSearchForm.search_demand_for;

        return <div className="modal fade" id={this.listFilterFormModalId} tabIndex="-1">
            <div className="modal-dialog modal-lg">-
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Item Demand Search</h5>
                    </div>
                    <div className="modal-body">
                        <form id={this.listFilterFormModalId + 'Form'} onSubmit={this.submitItemDemandSearchForm}>
                        <>
                            <div className="row my-3 align-items-center">
                                <label className="col-sm-2 col-form-label col-form-label-sm  ">Transaction ID</label>
                                <div className="col-sm-4">
                                    <input
                                        name="search_transaction_id"
                                        type="text"
                                        value={this.state.ItemDemandSearchForm.search_transaction_id}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={(e) => this.formInputHandler(e, "ItemDemandSearchForm")}
                                        placeholder="Please enter Transaction ID"
                                        style={{ height: "30px", fontSize: "93%" }}
                                    />
                                </div>
                                <label className="col-sm-1 col-form-label col-form-label-sm  ">Title</label>
                                <div className="col-sm-5">
                                    <input
                                        name="search_title"
                                        type="text"
                                        value={this.state.ItemDemandSearchForm.search_title}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={(e) => this.formInputHandler(e, "ItemDemandSearchForm")}
                                        placeholder="Please enter Title"
                                        style={{ height: "30px", fontSize: "93%" }}
                                    />
                                </div>


                            </div>

                            <div className="row my-3 align-items-center">
                                <label className="col-sm-2 col-form-label col-form-label-sm  ">Status</label>
                                <div className="col-sm-4">
                                    <TapSelect
                                        options={this.state.allStatusOptions}
                                        changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'search_status_ids')}
                                        isSearchable={true}
                                        isClearable={true}
                                        isMulti={true}

                                        value={this.state.allStatusOptions.filter(s => this.state.ItemDemandSearchForm.search_status_ids.includes(s.value))}
                                        placeholder="Select Status"
                                        containerHeight="30px"
                                        fontSize="93%"
                                    />
                                </div>
                                    <label className="col-sm-1 col-form-label col-form-label-sm  ">Tag Category</label>
                                    <div className="col-sm-5">
                                        <TapSelect
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder="All"
                                            containerHeight="30px"
                                            fontSize="93%"
                                            options={this.state.userFilters}
                                            value={this.state.userFilters.find(r => r.value === this.state.ItemDemandSearchForm.tagged_user_filter)}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'tagged_user_filter')}
                                        />
                                    </div>
                            </div>

                            <div className="row my-3 align-items-center">
                                <label className="col-sm-2 col-form-label col-form-label-sm  ">Warehouse</label>
                                <div className="col-sm-10">
                                    <TapSelect
                                        options={this.state.all_warehouses}
                                        changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'search_warehouse_ids')}
                                        value={this.state.all_warehouses.filter(u => this.state.ItemDemandSearchForm?.search_warehouse_ids?.includes(u.value))}
                                        isSearchable={true}
                                        isMulti={true}
                                        isClearable={true}
                                        placeholder="Select Warehouses"
                                        containerHeight="30px"
                                        fontSize="93%"
                                    />
                                </div>
                            </div>
                            <div className="row my-3 align-items-center">
                                <label className="col-sm-2 col-form-label col-form-label-sm ">Item</label>
                                <div className="col-sm-10">
                                    <InputItemSearch
                                        placeholder="Search Item"
                                        isMulti={true}
                                        changeEvent={(selectedOption) => {
                                            this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'search_item_ids');
                                            this.setState({
                                                searchedItems: selectedOption ? selectedOption : null
                                            }, () => { });
                                        }}
                                        containerHeight="30px"
                                        fontSize="93%"
                                        value={this.state.searchedItems.length > 0 ? this.state.searchedItems.map(a => { a.label = a.display_label; return a; }) : []}
                                    />
                                </div>

                            </div>
                            <div className="row my-3 align-items-center">
                                <label className="col-sm-2 col-form-label col-form-label-sm  ">Item Tags</label>
                                <div className="col-sm-10">
                                    <TapSelect
                                        options={this.state.allItemTags}
                                        changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'search_item_tags')}
                                        value={this.state.allItemTags.filter(u => this.state.ItemDemandSearchForm?.search_item_tags?.includes(u.value))}
                                        isSearchable={true}
                                        isMulti={true}
                                        isClearable={true}
                                        placeholder="Select Item Tags"
                                        containerHeight="30px"
                                        fontSize="93%"
                                    />
                                </div>
                            </div>
                            <div className="row my-3 align-items-center">
                                <label className="col-sm-2 col-form-label col-form-label-sm ">Demand For</label>
                                <div className="col-sm-10">
                                    <TapSelect
                                        changeEvent={(selectedOption) => {
                                            this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'search_demand_for', () => {
                                                this.setState({
                                                    searchedAssets: [],
                                                    searchedEmployees: [],
                                                    searchedSubassembly :   [],
                                                    searchedWorkstation : null,
                                                    searchCustomers: [],
                                                    searchVendors: [],

                                                    ItemDemandSearchForm: {
                                                        ...this.state.ItemDemandSearchForm,
                                                        search_asset_ids: [],
                                                        search_employee_ids: [],
                                                        search_workstation_ids: [],
                                                        search_sub_assembly_ids :   [],
                                                        search_customer_ids: [],
                                                        search_vendor_ids: [],
                                                    }
                                                })
                                            });
                                        }}
                                        options={this.state.allIndentOptions}
                                        isSearchable={true}
                                        isClearable={true}
                                        containerHeight="30px"
                                        fontSize="93%"
                                        value={this.state.allIndentOptions.find(s => s.value == search_demand_for)}
                                        placeholder="Select Demand For"
                                    />
                                </div>
                            </div>
                            {search_demand_for ?
                            <div className="row my-3 align-items-center">
                                <label className="col-sm-2 col-form-label col-form-label-sm">
                                {
                                    this.state.allIndentOptions.find(s => s.value == search_demand_for)?.label
                                }
                                </label>
                                <div className="col-sm-10">
                                    {search_demand_for == "asset" 
                                    ?
                                    <InputAssetSearch
                                        changeEvent={(selectedOption) => {
                                            this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'search_asset_ids');
                                            this.setState({ searchedAssets: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                        }}
                                        placeholder="Search Asset"
                                        isMulti={true}
                                        containerHeight="30px"
                                        fontSize="93%"
                                        value={this.state.searchedAssets.length > 0 ? this.state.searchedAssets.map(a => { a.label = a.display_label; return a; }) : []}
                                    />
                                    : search_demand_for == "workstation"
                                    ? 
                                    <InputWorkstationSearch
                                        placeholder="Search Workstation"
                                        changeEvent={(selectedOption) => {
                                            this.setState({
                                                searchedWorkstation: selectedOption ? selectedOption : '',
                                                ItemDemandSearchForm: { ...this.state.ItemDemandSearchForm, search_workstation_ids: selectedOption ? [selectedOption.value] : [] }
                                            });
                                            // this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'search_workstation_ids')
                                        }}
                                        menuPlacement="top"
                                        isMulti={false}
                                        value={this.state.searchedWorkstation && this.state.searchedWorkstation}
                                        containerHeight="30px"
                                        fontSize="93%"
                                    />
                                    : search_demand_for == "employee"
                                    ?
                                    <InputEmployeeSearch
                                        placeholder="Please Select Employee"
                                        changeEvent={(selectedOption) => {
                                            this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'search_employee_ids');
                                            this.setState({ searchedEmployees: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                        }}
                                        isMulti={true}
                                        containerHeight="30px"
                                        fontSize="93%"
                                        value={this.state.searchedEmployees.length > 0 ? this.state.searchedEmployees.map(a => { a.label = a.label; return a; }) : []}
                                    />
                                    : search_demand_for == 'sub_assembly' ?  
                                    <InputSubAssemblySearch
                                        changeEvent={(selectedOption) => {
                                            this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'search_sub_assembly_ids');
                                            this.setState({ searchedSubassembly: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                        }}
                                        placeholder="Search Sub Assembly"
                                        isMulti={true}
                                        containerHeight="30px"
                                        fontSize="93%"
                                        value={this.state.searchedSubassembly.length > 0 ? this.state.searchedSubassembly.map(a => { a.label = a.label; return a; }) : []}
                                    /> 
                                    : search_demand_for === 'customer' ?  
                                    <InputCustomerSearch
                                        changeEvent={(selectedOption) => {
                                            this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'search_customer_ids');
                                            this.setState({ searchCustomers: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                        }}
                                        placeholder="Search Customers"
                                        isMulti={true}
                                        containerHeight="30px"
                                        fontSize="93%"
                                        value={this.state.searchCustomers.length > 0 ? this.state.searchCustomers.map(a => { a.label = a.label; return a; }) : []}
                                    />
                                    : search_demand_for === 'vendor' ? 
                                    <InputVendorSearch
                                        changeEvent={(selectedOption) => {
                                            this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'search_vendor_ids');
                                            this.setState({ searchVendors: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                        }}
                                        placeholder="Search Vendor"
                                        isMulti={true}
                                        containerHeight="30px"
                                        fontSize="93%"
                                        value={this.state.searchVendors.length > 0 ? this.state.searchVendors.map(a => { a.label = a.label; return a; }) : []}
                                    />
                                    : null
                                    }
                                </div>
                            </div> 
                            : 
                            null
                            }
                                    
                            <div className="row my-3">
                                <label className="col-sm-2 col-form-label col-form-label-sm">Ticket</label>
                                <div className="col-sm-10">
                                    <InputTicketSearch
                                        containerHeight="30px"
                                        fontSize="93%"
                                        changeEvent={(selectedOption) => {
                                            this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'search_ticket_ids');
                                            this.setState({ searchedTickets: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                        }}
                                        isMulti={true}
                                        menuPlacement="top"
                                        value={this.state.searchedTickets.length > 0 ? this.state.searchedTickets.map(a => { a.label = a.display_label; return a; }) : []}
                                        search_exclude_ticket_status={[0,26, 10]}
                                    />
                                </div>
                            </div>
                            <div className="row my-3 align-items-center">
                                <label className="col-sm-2 col-form-label col-form-label-sm  ">Tagged User</label>
                                <div className="col-sm-4">
                                    <TapSelect
                                        isSearchable={true}
                                        isClearable={true}
                                        isMulti={true}
                                        placeholder="Tagged User"
                                        containerHeight="30px"
                                        fontSize="93%"
                                        options={this.state.allUsers}
                                        value={this.state.allUsers.filter(s => this.state.ItemDemandSearchForm.tagged_user_ids.includes(s.value))}
                                        changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'tagged_user_ids')}
                                    />
                                </div>

                                <label className="col-sm-1 col-form-label col-form-label-sm">Project</label>
                                <div className="col-sm-5">
                                <InputProjectSearch
                                    changeEvent={(selectedOption) => {
                                        this.tapSelectChange(selectedOption, 'ItemDemandSearchForm', 'search_project_ids');
                                        this.setState({ searchedProjects: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                    }}
                                    placeholder="Search Project"
                                    isMulti={true}
                                    containerHeight="30px"
                                    fontSize="93%"
                                    value={this.state.searchedProjects.length > 0 ? this.state.searchedProjects.map(a => { a.label = a.display_label; return a; }) : []} />
                                    {/* <input
                                        type="text"
                                        name="search_project_id"
                                        className="form-control form-control-sm"
                                        placeholder="Project"
                                        autoComplete="off"
                                        value={this.state.ItemDemandSearchForm.search_project_id}
                                        onChange={(e) => this.formInputHandler(e, "ItemDemandSearchForm")}
                                    /> */}
                                </div>
                            </div>

                                
                            <div className="row my-3 align-items-center">
                                <label className="col-sm-2 col-form-label col-form-label-sm ">Transaction Period</label>
                                <div className="col-sm-10">
                                    <PeriodSelectionWithCustom
                                        periods={this.state.all_periods ? this.state.all_periods : []}
                                        value={this.state.ItemDemandSearchForm.date_range}
                                        startDate={this.state.ItemDemandSearchForm.date_range_start}
                                        endDate={this.state.ItemDemandSearchForm.date_range_end}
                                        onSelectPeriod={(period, startDate, endDate) => {
                                            this.setState({
                                                ItemDemandSearchForm
                                                    : {
                                                    ...this.state.ItemDemandSearchForm,
                                                    date_range: period,
                                                    date_range_start: startDate ? startDate : null,
                                                    date_range_end: endDate ? endDate : null
                                                }
                                            });
                                        }}
                                        className="form-control-sm"
                                        containerHeight="30px"
                                        fontSize="93%"
                                    />
                                </div>
                            </div>

                        </>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" disabled={this.state.listFilterFormSubmitting} data-bs-dismiss="modal">Close</button>
                        <button type="submit" className="btn btn-primary" form={this.listFilterFormModalId + 'Form'} disabled={this.state.listFilterFormSubmitting} >Save {this.state.listFilterFormSubmitting && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                    </div>
                </div>
            </div>
        </div>
    }

    releasedItemModalJsx               =        ()             =>        {
        return (
            <div className="modal fade" id="releasedItemModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Cancel Item</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={this.submitCancelItemForm}>
                            <div className="modal-body">
                                {this.state.cancel_item_loading ? <Loader />
                                    : <Ax>
                                        <table className="table table-bordered table-responsive bg-white ">
                                            <thead className="table-secondary">
                                                <tr className="text-end">
                                                    <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                                                    <th scope="col" className="text-start">Item Details</th>
                                                    <th scope="col" style={{ width: "12%" }}>Qty</th>
                                                    <th scope="col" style={{ width: "14%" }}>Cancelled Qty</th>
                                                    <th scope="col" style={{ width: "14%" }}>Pending Qty</th>
                                                    <th scope="col" style={{ width: "12%" }}>Cancel</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.cancelledItemList.map((i, k) => {
                                                    return <tr className="text-end" key={k}>
                                                        <td className="text-center align-middle">{k + 1}</td>
                                                        <td className='text-start'>{i.item_profile ? <div><span className="fw-bold">{i.item_profile.name}</span><br />
                                                            <div className="form-text"><b>Code: </b>{i.item_profile.item_code}</div>
                                                            <div className="form-text"><b>Mfr: </b>{i.item_profile?.manufacturer?.name ?? '-'} (MPN : {i.item_profile?.manufacturer_part_no ?? "-"} )</div>
                                                            <div className="form-text"> {
                                                                i.item_profile?.tags?.length > 0
                                                                    ? (i.item_profile?.tags.map((item, k) => <span key={k} className="badge bg-secondary">{item.name}</span>))
                                                                    : '-'
                                                            }</div>
                                                            <div className="form-text"><b>Remark: </b>{i.remark ?? "-"}</div>
                                                        </div>
                                                            : null}</td>
                                                        <td>{i.qty ? i.qty : 0}</td>
                                                        <td>{i.released_qty ? i.released_qty : 0}</td>
                                                        <td>{i.pending_qty ? i.pending_qty : 0}</td>

                                                        <td className="text-end">
                                                             <TapInputNumber
                                                              name="new_released_qty"
                                                            value={this.state.cancelledItemList[k]?.new_released_qty}
                                                            onChange={(e) => this.dynamicInputHandlerByKey(null, k, 'cancelledItemList',null,"new_released_qty",e)}
                                                            placeholder="Cancel Qty"
                                                            required={true}
                                                            max={i.pending_qty}
                                                        /></td>
                                                    </tr>
                                                })}
                                            </tbody>
                                        </table>
                                        <div className="row align-items-center ">
                                            <div className="col-sm-6">
                                                <label htmlFor="notes" className="form-label">Notes</label>
                                                <div> <textarea
                                                    name="notes"
                                                    value={this.state.cancelledItemForm.notes}
                                                    onChange={(e) => this.formInputHandler(e, 'cancelledItemForm')}
                                                    className="form-control"
                                                    style={{ height: "100px" }}
                                                /></div>

                                            </div>
                                        </div>
                                    </Ax>}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={this.state.cancelItemFormSubmitting}
                                    onClick={() => { this.setState({ cancelledItemList: [] }) }}>Close  {this.state.cancelItemFormSubmitting ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>
                                <button type="submit" className="btn btn-primary" disabled={this.state.cancelItemFormSubmitting}>Save  {this.state.cancelItemFormSubmitting ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        );
    }


    render                              =   ()  =>  {
        return <ApplicationLayout>
            <Helmet><title>Item Demand Listing</title></Helmet>
            {this.ItemDemandListjsx()}
            <ItemDetailsModal ref={this.item_profilesRef} />
            {this.listFilterFormModalJsx()}
            {this.releasedItemModalJsx()}
        </ApplicationLayout>;
    }

}



const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        all_periods             :   state.app && state.app.all_periods ? state.app.all_periods : [],
        all_warehouses          :   state.app && state.app.warehouses ? state.app.warehouses : [],
        item_tags               :   state.app && state.app.item_tags ? state.app.item_tags : [],
        isc_configuration       :   state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        permissions             :   state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []

    };

//         all_periods             :   state.app && state.app.all_periods ? state.app.all_periods : [],
//         all_warehouses          :   state.app && state.app.warehouses ? state.app.warehouses : [],
//         isc_configuration       :   state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
//         permissions             :   state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []

};

export default connect(mapStateToProps, null, null, { forwardRef: true })(ItemDemandList);



